import styled, { css } from 'styled-components';

export const Input = styled.input`
  width: 100%;
  appearance: none;
  box-sizing: border-box;
  border: 2px solid black;
  padding: 0.5rem 0.25rem;
  font-weight: 500;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  font-family: ${(props) => props.theme.fonts.alt};
  margin-bottom: 0.5rem;
  text-align: left;
`;


export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 0.75rem;
`;

export const Title = styled.div`
  font-family: ${(props) => props.theme.fonts.alt};
  text-transform: uppercase;
  margin-bottom: 1rem;
`;

const Wrapper = styled.div`
  width: 100%;
  margin-top: 2rem;
  overflow: hidden;
  padding-bottom: 1rem;
  padding-right: 0.5rem;
`;

export default Wrapper;